import { render, staticRenderFns } from "./BaseConnect.vue?vue&type=template&id=11358031&scoped=true&"
import script from "./BaseConnect.vue?vue&type=script&lang=js&"
export * from "./BaseConnect.vue?vue&type=script&lang=js&"
import style0 from "./BaseConnect.vue?vue&type=style&index=0&id=11358031&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11358031",
  null
  
)

export default component.exports